// Utility to fix stuck resignations at manager_approved status
export const fixResignationStatus = async (empCode) => {
  try {
    console.log(`🔧 Fixing resignation status for ${empCode}...`);
    
    // Method 1: Try direct status update
    const response1 = await fetch('https://hrms.gtplindia.com:8443/offboarding/force-status-update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'emp-code': empCode
      },
      body: JSON.stringify({
        status: 'pending_hr_approval',
        force_update: true,
        reason: 'Manual status correction - final submission completed'
      })
    });
    
    if (response1.ok) {
      console.log('✅ Status updated successfully via force-update endpoint');
      return await response1.json();
    }
    
    // Method 2: Try final docs submission with explicit status
    const response2 = await fetch('https://hrms.gtplindia.com:8443/offboarding/final-docs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'emp-code': empCode
      },
      body: JSON.stringify({
        personal_email: 'temp@example.com',
        final_submission: true,
        assets_confirmed: true,
        handover_completed: true,
        force_hr_forward: true,
        status: 'pending_hr_approval'
      })
    });
    
    if (response2.ok) {
      console.log('✅ Status updated successfully via final-docs endpoint');
      return await response2.json();
    }
    
    // Method 3: Direct database update (if API supports it)
    const response3 = await fetch(`https://hrms.gtplindia.com:8443/offboarding/resignation/${empCode}/update-status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        new_status: 'pending_hr_approval',
        updated_by: 'system_fix',
        notes: 'Status corrected - final submission completed'
      })
    });
    
    if (response3.ok) {
      console.log('✅ Status updated successfully via direct update endpoint');
      return await response3.json();
    }
    
    throw new Error('All update methods failed');
    
  } catch (error) {
    console.error('❌ Failed to fix resignation status:', error);
    throw error;
  }
};

// Quick fix for EMP8383
export const fixEMP8383 = () => fixResignationStatus('EMP8383');